module.exports = __webpack_public_path__ + "img/abo-3.34d1e53f.png";